import { useHederProfileBlock } from '@/hooks/useHederProfileBlock';
import { Select, SelectTrigger, SelectContent, SelectValue, SelectItem } from './ui//select';
import AvatarProfile from './AvatarProfile';
import { setCookie } from '@/utils/cookies';
import { useQueryClient } from '@tanstack/react-query';
import { HeaderProfileBlockSkeleton } from './HeaderProfileBlockSkeleton';
import {
  getAppointmentsQueryKey,
  getBonusesQueryKey,
  getClientQueryKey,
  getClubsQueryKey,
  getPurchaseHistoryQueryKey,
  getSwimmersDiaryQueryKey,
  getTicketsQueryKey,
  getVisitsHistoryQueryKey,
} from '@/utils/queryKeys';

const HeaderProfileBlock = () => {
  const {
    userNames,
    userTokens,
    selectedUserId,
    setSelectedUserId,
    isLoading,
    closeAccordionToggle,
  } = useHederProfileBlock();
  const queryClient = useQueryClient();
  if (isLoading) {
    return <HeaderProfileBlockSkeleton />;
  }

  return (
    <>
      <Select
        value={selectedUserId}
        onValueChange={async (value: string) => {
          const index = userNames.findIndex((i) => i.id === value);
          setCookie('user_token', userTokens[index]);
          setSelectedUserId(userNames[index].fullName);
          closeAccordionToggle();
          await queryClient.invalidateQueries({ queryKey: getClientQueryKey() });
          await queryClient.invalidateQueries({ queryKey: getClubsQueryKey() });
          await queryClient.invalidateQueries({ queryKey: getAppointmentsQueryKey() });
          await queryClient.invalidateQueries({ queryKey: getTicketsQueryKey() });
          await queryClient.invalidateQueries({ queryKey: getPurchaseHistoryQueryKey() });
          await queryClient.invalidateQueries({ queryKey: getBonusesQueryKey() });
          await queryClient.invalidateQueries({ queryKey: getVisitsHistoryQueryKey() });
          await queryClient.invalidateQueries({ queryKey: getSwimmersDiaryQueryKey() });
        }}
        onOpenChange={(open) => {
          if (open) {
            document.body.style.overflow = 'auto';
          }
        }}>
        <SelectTrigger className="text-base focus:outline-none focus-visible:ring-0 focus:ring-0 gap-3 min-w-[auto]">
          <AvatarProfile />
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="text-base w-[auto] min-w-[auto]">
          {userNames.map((item) => (
            <SelectItem key={item.id} value={item.id} className="text-base">
              {item.fullName}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  );
};

export default HeaderProfileBlock;
